<template>
  <div>
    <b-modal
      ref="feeFreeModal"
      title="No Purchase Required, Fees Waved"
      :ok-only="true"
      >You have selected a date on which fees are waived for {{ name }}. You
      will be allowed entry on the specified date with or without a pass. Enjoy
      your visit!</b-modal
    >
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "FeeFreeDays",
  data() {
    return {
      name: ""
    };
  },
  props: ["startdate", "free_days"],
  watch: {
    startdate() {
      if (!this.free_days) {
        return;
      }

      this.free_days.forEach(day => {
        let passstartdate = moment.utc(this.startdate, "MM/DD/YYYY");
        let freedate = moment.utc(day.date);

        //Check if a date range
        if (day.end) {
          let enddate = moment.utc(day.end);
          let date = freedate;
          while (date <= enddate) {
            if (
              passstartdate.format("MM/DD/YYYY") == date.format("MM/DD/YYYY")
            ) {
              this.name = day.name;
              //Show modal
              this.$refs.feeFreeModal.show();
            }
            date.add(1, "days");
          }
        } else if (
          passstartdate.format("MM/DD/YYYY") == freedate.format("MM/DD/YYYY")
        ) {
          this.name = day.name;
          //Show modal
          this.$refs.feeFreeModal.show();
        }
      });
    }
  }
};
</script>
